export default "__VITE_ASSET__ba9deb5c__"